export const getConfig = (key, fallback = false) => {
    return global.__CONFIG && global.__CONFIG[key] || process.env[key] || fallback;
};


// WEBPACK FOOTER //
// ./src/felles/utils/configUtils.js